/**
 * Custom hook for handling slide drag and drop reordering
 */ import { useState } from 'react';
/**
 * Hook for managing slide drag and drop state and handlers
 * @returns Drag and drop state and handler functions
 */ export function useSlideDragAndDrop() {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [draggedOverIndex, setDraggedOverIndex] = useState(null);
    const handleDragStart = (e, index)=>{
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', index.toString());
    };
    const handleDragOver = (e, index)=>{
        e.preventDefault(); // Allow drop
        e.dataTransfer.dropEffect = 'move';
        if (draggedIndex !== null && draggedIndex !== index) {
            setDraggedOverIndex(index);
        }
    };
    const handleDrop = (e, dropIndex, onReorder)=>{
        e.preventDefault();
        if (draggedIndex !== null && draggedIndex !== dropIndex) {
            onReorder(draggedIndex, dropIndex);
        }
        setDraggedIndex(null);
        setDraggedOverIndex(null);
    };
    const handleDragEnd = ()=>{
        setDraggedIndex(null);
        setDraggedOverIndex(null);
    };
    return {
        draggedIndex,
        draggedOverIndex,
        handleDragStart,
        handleDragOver,
        handleDrop,
        handleDragEnd
    };
}
